module.exports = __webpack_public_path__ + "static/media/RPA.8fd12b4f.jpg";